export const faq = [
  {
    qustion: "How do I Mint Mpad Chimp",
    answer:
      "A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found as a welcome guest in many households across the world. ",
    key: "1",
  },
  {
    qustion: "How Many Chimp is Available To Be Minted",
    answer:
      "A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found as a welcome guest in many households across the world. ",
    key: "2",
  },
  {
    qustion: "How Much Does A Chimp Cost?",
    answer:
      "A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found as a welcome guest in many households across the world. ",
    key: "3",
  },
  {
    qustion: "Will The Community Wallet Continue To Get Additional Funds",
    answer:
      "A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found as a welcome guest in many households across the world. ",
    key: "4",
  },
];
